<template>
  <div class="controls">
    <div class="w-full h-full inset-0 absolute z-0">
      <img class="w-full h-full" src="/showroom/media/list-splashscreen.jpg" />
    </div>
    <!-- buttons -->
    <div class="z-10 relative w-full h-full" :class="{ 'aniControls_buttonsIn' : addAnimation }">
        <button @click="goBack()" class="btn btn-green btn-small btn-home opacity-0">{{ $t('overview-back') }}</button>
        <!-- product infos -->
        <list-point product="thermostate" shift="none" category="steuerungen" i18category="control" />
        <list-point product="schalter" shift="none" category="steuerungen" i18category="control" />
        <list-point product="bedienoberflaechen" shift="none" category="steuerungen" i18category="control" />
        <list-point product="codeschalter" shift="none" category="steuerungen" i18category="control" />
        <list-point product="mainboards" shift="none" category="steuerungen" i18category="control" />
        <list-point product="energieregler" shift="none" category="steuerungen" i18category="control" />
    </div>
  </div>
</template>

<script>
import ListPoint from '@/components/ListPoint';

export default {
    name: 'Controls',
    components: {
        'list-point': ListPoint,
    },
    data() {
        return {
            addAnimation: false,
            touch: false,
        }
    },
  methods: {
    goBack() {
      this.$router.push({ path: '/', query: { skip: 1, lang: this.$i18n.locale }})
    }
  },
  mounted() {
    this.$i18n.locale = this.$route.query.lang;
    setTimeout(() => {
      this.addAnimation = true;
    }, 1000)
  }
}
</script>

<style lang="scss">
.aniControls_buttonsIn .product-info {
  animation: fadeIn100 0.3s ease forwards;
}
.aniControls_buttonsIn .btn {
  animation: reveal100 0.3s ease forwards;
}

// set position for prodcut info points
.product-info.thermostate { bottom: 49%; left: 15.8%; z-index: 6; }
.product-info.schalter { bottom: 49%; left: 36%; z-index: 5; }
.product-info.bedienoberflaechen { bottom: 49%; left: 50.5%; z-index: 4; }
.product-info.codeschalter { bottom: 49%; left: 57%; z-index: 3; }
.product-info.mainboards { bottom: 49%; left: 72%; z-index: 2; }
.product-info.energieregler { bottom: 49%; left: 79.5%; z-index: 1; }
</style>